import React, { Fragment } from 'react'
import {  Container} from '@material-ui/core'
import { Helmet } from 'react-helmet'
import { PageBanner } from '../../components'

// const useStyles = makeStyles((theme) => ({
    
//     sectionHeading: {
//         fontSize: '64px',
//         color: theme.palette.secondary.light,
//         fontWeight: 700,
//         letterSpacing: 0.1,
//         margin: '0 20px',
//         lineHeight: '60px',
//         [theme.breakpoints.down('md')]:{
//             fontSize: '54px',
//         },
//         [theme.breakpoints.down('sm')]:{
//             fontSize: '45px',
//             lineHeight: '40px',
//             marginTop:'30px'
//         }
//     },
// }))

function FeaturedPublication() {
    // const classes = useStyles()
    return (
        <Fragment>
            <Helmet>
                <title>Featured Publications - d2p</title>
            </Helmet>
            <PageBanner title="Featured Publications" image='/assets/images/bg4.jpg' />
            <div style={{margin: '70px 0'}}>
                <Container style={{textAlign:'justify'}}>
                    <p>
                        Throughout the 1990s, the crystallized form of the laboratory-engineered stimulant known as methamphetamine, was the world’s most lucrative substance. The street value in Hawaii put the highly-addictive drug at $1,000 to $2,000 per gram (an amount equal to a packet of sweetener).
                    </p>
                    <p>
                        During the decade, the price of gold fluctuated at $342 per ounce, making ice roughly 125 times more valuable than Earth’s third most precious commodity.
                    </p>
                    <p>
                        Those who entered the ice trafficking industry at the time became ridiculously wealthy, while developing methods to smuggle the vaporizing crystal, first from Japan, then from Mexico, into the United States for distribution abroad.
                    </p>
                    <p>
                        Declared an “epidemic” by Congress in 1998, laws were passed and funding was increased to aid law enforcement in battling the spread of ice, forcing traffickers like Schulze to stay one step ahead of the crusade to stem the drug’s flow.
                    </p>
                    <p>
                        The METHod is a memoir detailing the life of an ice trafficker in the 1990s. The powerful narrative takes the reader on an adventurous journey, from Honolulu, Hawaii to Atlanta, Georgia to what would become his base of operations, Las Vegas, Nevada.
                    </p>
                    <p>
                        Like the drug traffickers portrayed in Breaking Bad, Blow, and American Made, Schulze experienced events of highlight and tragedy, punctuated with bouts of betrayal.
                    </p>
                    <p>
                        Unlike other stories, this one is true.
                    </p>
                </Container>
            </div>
        </Fragment>
    )
}

export default FeaturedPublication
